/* ==========================================================================
   Koolseed — Görsel inceleyici

   Tam ekran görsel görüntüleyici: yakınlaştırma, gezinme ve galeri geçişi.
   Ürün detay galerisi ile yorum fotoğrafları aynı bileşeni kullanıyor.

   Yakınlaştırma davranışı:
     · Görsele tıklayınca tıklanan nokta merkez alınarak yakınlaşır.
     · Yakınken masaüstünde fare hareketi görselin üzerinde gezdirir
       (imleç nereye giderse görselin o bölgesi ortaya gelir).
     · Dokunmatikte sürükleyerek gezinilir.
     · Uzakken yatay sürükleme önceki/sonraki görsele geçirir.
   ========================================================================== */

(function () {
  'use strict';

  var ZOOM = 2.6;

  class KsViewer extends HTMLElement {
    connectedCallback() {
      this.img = this.querySelector('[data-viewer-img]');
      this.stage = this.querySelector('[data-viewer-stage]');
      this.titleEl = this.querySelector('[data-viewer-title]');
      this.posEl = this.querySelector('[data-viewer-pos]');
      this.sideEl = this.querySelector('[data-viewer-side]');
      this.thumbsEl = this.querySelector('[data-viewer-thumbs]');
      this.zoomBtn = this.querySelector('[data-viewer-zoom]');
      this.prevBtn = this.querySelector('[data-viewer-prev]');
      this.nextBtn = this.querySelector('[data-viewer-next]');

      this.items = [];
      this.index = 0;
      this.zoomed = false;
      this.origin = { x: 50, y: 50 };
      this.release = null;

      // Tetikleyiciler sayfanın her yerinde olabilir (galeri, yorumlar);
      // tek bir belge dinleyicisi hepsini karşılıyor.
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-viewer-open]');
        if (!trigger) return;
        event.preventDefault();
        this.openFrom(trigger);
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-ks-close]')) { this.close(); return; }
        if (event.target.closest('[data-viewer-prev]')) { this.step(-1); return; }
        if (event.target.closest('[data-viewer-next]')) { this.step(1); return; }
        if (event.target.closest('[data-viewer-zoom]')) { this.toggleZoom(); return; }

        const thumb = event.target.closest('[data-viewer-thumb]');
        if (thumb) { this.go(Number(thumb.dataset.viewerThumb)); return; }

        if (event.target === this.img) { this.toggleZoom(event); return; }
        // Görselin dışına tıklayınca kapansın.
        if (event.target === this.stage || event.target === this) this.close();
      });

      document.addEventListener('keydown', (event) => {
        if (this.hidden) return;
        if (event.key === 'Escape') { this.close(); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
      });

      this.bindPointer();
    }

    /* ---- Açılış ------------------------------------------------------------ */

    openFrom(trigger) {
      const gallery = trigger.closest('[data-viewer-gallery]');
      const triggers = gallery
        ? Array.from(gallery.querySelectorAll('[data-viewer-open]'))
        : [trigger];

      this.items = triggers.map((el) => ({
        src: el.dataset.src || '',
        alt: el.dataset.alt || '',
        thumb: el.dataset.thumb || el.dataset.src || ''
      }));
      this.index = Math.max(0, triggers.indexOf(trigger));
      this.trigger = trigger;

      if (this.titleEl) this.titleEl.textContent = (gallery && gallery.dataset.viewerTitle) || '';
      this.renderSide(trigger);
      this.renderThumbs();
      this.render();

      this.hidden = false;
      window.requestAnimationFrame(() => this.classList.add('is-open'));
      window.KS.lockScroll(true);
      this.release = window.KS.trapFocus(this, this.querySelector('[data-ks-close]'));
    }

    /* Yan panel — yorum fotoğraflarında yorumun kendisi görselin yanında durur. */
    renderSide(trigger) {
      if (!this.sideEl) return;
      const scope = trigger.closest('[data-viewer-scope]');
      const template = scope && scope.querySelector('template[data-viewer-side]');

      this.sideEl.textContent = '';
      if (!template) {
        this.sideEl.hidden = true;
        this.classList.remove('has-side');
        return;
      }
      this.sideEl.appendChild(template.content.cloneNode(true));
      this.sideEl.hidden = false;
      this.classList.add('has-side');
    }

    renderThumbs() {
      if (!this.thumbsEl) return;
      this.thumbsEl.textContent = '';
      if (this.items.length < 2) { this.thumbsEl.hidden = true; return; }

      this.thumbsEl.hidden = false;
      this.items.forEach((item, i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ks-viewer__thumb';
        button.setAttribute('role', 'tab');
        button.dataset.viewerThumb = String(i);
        const img = document.createElement('img');
        img.src = item.thumb;
        img.alt = '';
        img.loading = 'lazy';
        button.appendChild(img);
        this.thumbsEl.appendChild(button);
      });
    }

    render() {
      const item = this.items[this.index];
      if (!item) return;

      this.resetZoom();
      this.img.src = item.src;
      this.img.alt = item.alt;

      const many = this.items.length > 1;
      if (this.posEl) this.posEl.textContent = many ? (this.index + 1) + ' / ' + this.items.length : '';
      if (this.prevBtn) this.prevBtn.hidden = !many;
      if (this.nextBtn) this.nextBtn.hidden = !many;

      if (this.thumbsEl) {
        this.thumbsEl.querySelectorAll('[data-viewer-thumb]').forEach((button, i) => {
          const on = i === this.index;
          button.classList.toggle('is-active', on);
          button.setAttribute('aria-selected', String(on));
        });
      }
    }

    go(index) {
      if (index === this.index || !this.items[index]) return;
      this.index = index;
      this.render();
    }

    step(delta) {
      if (this.items.length < 2) return;
      this.index = (this.index + delta + this.items.length) % this.items.length;
      this.render();
    }

    /* ---- Yakınlaştırma ------------------------------------------------------ */

    toggleZoom(event) {
      if (this.zoomed) this.resetZoom();
      else this.applyZoom(event);
    }

    /** Tıklanan noktayı merkez alarak yakınlaştırır. */
    applyZoom(event) {
      this.zoomed = true;
      if (event) this.origin = this.pointToPercent(event.clientX, event.clientY);
      this.img.style.transformOrigin = this.origin.x + '% ' + this.origin.y + '%';
      this.img.style.transform = 'scale(' + ZOOM + ')';
      this.classList.add('is-zoomed');
      if (this.zoomBtn) this.zoomBtn.setAttribute('aria-pressed', 'true');
    }

    resetZoom() {
      this.zoomed = false;
      this.origin = { x: 50, y: 50 };
      this.img.style.transform = '';
      this.img.style.transformOrigin = '';
      this.classList.remove('is-zoomed');
      if (this.zoomBtn) this.zoomBtn.setAttribute('aria-pressed', 'false');
    }

    /** İmleç konumunu görselin yüzdesine çevirir (0-100 arası kırpılmış). */
    pointToPercent(clientX, clientY) {
      const box = this.img.getBoundingClientRect();
      const x = ((clientX - box.left) / box.width) * 100;
      const y = ((clientY - box.top) / box.height) * 100;
      return {
        x: Math.min(100, Math.max(0, x)),
        y: Math.min(100, Math.max(0, y))
      };
    }

    bindPointer() {
      let startX = 0;
      let dragging = false;
      let moved = false;

      // Masaüstü: yakınken fare hareketi görselin üzerinde gezdirir.
      this.stage.addEventListener('mousemove', (event) => {
        if (!this.zoomed || dragging) return;
        this.origin = this.pointToPercent(event.clientX, event.clientY);
        this.img.style.transformOrigin = this.origin.x + '% ' + this.origin.y + '%';
      });

      // Dokunmatik: yakınken sürükleyerek gezinme, uzakken kaydırarak geçiş.
      this.img.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && this.zoomed) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        this.lastPoint = { x: event.clientX, y: event.clientY };
      });

      this.img.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        if (Math.abs(event.clientX - startX) > 4) moved = true;
        if (!this.zoomed) return;

        event.preventDefault();
        const box = this.img.getBoundingClientRect();
        // Sürüklenen mesafeyi köken yüzdesine çevir; ters yönde kaydır ki
        // görsel parmakla birlikte hareket ediyormuş gibi dursun.
        const dx = ((event.clientX - this.lastPoint.x) / box.width) * 100;
        const dy = ((event.clientY - this.lastPoint.y) / box.height) * 100;
        this.origin = {
          x: Math.min(100, Math.max(0, this.origin.x - dx)),
          y: Math.min(100, Math.max(0, this.origin.y - dy))
        };
        this.img.style.transformOrigin = this.origin.x + '% ' + this.origin.y + '%';
        this.lastPoint = { x: event.clientX, y: event.clientY };
      });

      const end = (event) => {
        if (!dragging) return;
        dragging = false;
        if (!this.zoomed && moved && Math.abs(event.clientX - startX) > 60) {
          this.step(event.clientX < startX ? 1 : -1);
        }
      };
      this.img.addEventListener('pointerup', end);
      this.img.addEventListener('pointercancel', () => { dragging = false; });
      this.img.addEventListener('dragstart', (event) => event.preventDefault());
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      if (this.release) { this.release(); this.release = null; }
      window.KS.lockScroll(false);
      window.setTimeout(() => {
        this.hidden = true;
        this.img.src = '';
        this.resetZoom();
      }, 240);
      if (this.trigger) this.trigger.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('ks-viewer')) customElements.define('ks-viewer', KsViewer);
})();
